import React, { useState } from 'react'
import { format, getDay } from 'date-fns'
import { Avatar, Typography, FloatButton } from '@telavita-core/react-design-kit'
import { AnimatePresence } from 'framer-motion'

import { 
  CancelRecurrentReservationModal,
  CancelReservationDayModal, 
  CancelReservationQuestionModal 
} from 'containers/ModalManager/Modals'

import { WEEKDAYS_NAMES } from 'settings/dayPicker'

import * as S from './styles'
import { Reservation as IReservation } from 'models/Reservation'

interface ReservationProps {
  reservation: IReservation
  onRefresh: () => void
  patientPlansAllowReservation?: boolean
}

export const Reservation = ({
  reservation,
  onRefresh,
  patientPlansAllowReservation
}: ReservationProps): JSX.Element => {
  const {
    uuid,
    patientUsername,
    patientFullName,
    professionalUsername,
    professionalFullName,
    professionalPictureUrl,
    startDate,
    recurrencyExceptions
  } = reservation
  const weekday = WEEKDAYS_NAMES[getDay(startDate)]
  const hour = format(startDate, "HH'h'mm") // eslint-disable-line
  const [cancelOpen, setCancelOpen] = useState(false)
  const [questionCancelOpen, setQuestionCancelOpen] = useState(false)
  const [cancelReservationDayOpen, setCancelReservationDayOpen] = useState(false)

  const options = [{ 
    icon: 'MoreOptions', 
    label: 'Cancelar reserva', 
    onClick: () => setQuestionCancelOpen(state => !state) 
  }]

  return (
    <S.Container>
      <div className='avatar'>
        <Avatar
          alt={professionalFullName}
          src={professionalPictureUrl}
          size='large'
        />
      </div>
      <div className='schedule'>
        <S.ScheduleTimeContainer variant={
          patientPlansAllowReservation ? 'success' : 'error'
        }>
          <Typography variant='content1' weight='bold'>
            {weekday}
          </Typography>
          <Typography variant='content1' weight='bold'>
            às {hour}
          </Typography>
        </S.ScheduleTimeContainer>
        <S.ScheduleProfessionalInfoContainer variant={
          patientPlansAllowReservation ? 'success' : 'error'
        } className='scheduleProfessional'>
          <Typography variant='content3'>
            Com o psicólogo
          </Typography>
          <Typography variant='content2'>
            {professionalFullName}
          </Typography>
        </S.ScheduleProfessionalInfoContainer>
      </div>
      
      <div className='actions'>
        <FloatButton actions={options} />
      </div>

      <AnimatePresence>
        {questionCancelOpen && (
          <CancelReservationQuestionModal
            onClose={() => setQuestionCancelOpen(false)}
            onSelectSingleDay={() => setCancelReservationDayOpen(true)}
            onSelectAllReservation={() => setCancelOpen(true)}
            patientFullName={patientFullName}
            reservationHour={hour}
            reservationWeekday={weekday}
          />
        )}
      </AnimatePresence>
      {cancelReservationDayOpen && (
        <CancelReservationDayModal
          onClose={() => setCancelReservationDayOpen(false)}
          patientFullName={patientFullName}
          patientUsername={patientUsername}
          professionalFullName={professionalFullName}
          professionalUsername={professionalUsername}
          reservationStartdate={new Date(startDate)}
          reservationUUID={uuid}
          cancelledDates={recurrencyExceptions}
          onRefresh={onRefresh}
        />
      )}
      <CancelRecurrentReservationModal
        isProfessional={false}
        open={cancelOpen}
        onSetOpen={setCancelOpen}
        onRefresh={onRefresh}
        reservationUUID={uuid}
        reservationHour={hour}
        reservationWeekday={weekday}
        patientUsername={patientUsername}
        patientFullName={patientFullName}
        professionalUsername={professionalUsername}
        professionalFullName={professionalFullName}
      />
    </S.Container>
  )
}
